/**
 * Version 0.0.0
 *
 *
 * Author: Oded Sagir
 * @param  Object require -for adding dependencies
 * @return Object         -Class Object
 */
define(function(require) {
    'use strict';

    var template = require('registration-templates/plan-selection/assistedSaleView.tmpl');

    var Button = require("ui/button/Button");
    var StepIndicator = require("ui/stepIndicator/StepIndicator");
    var BillingManager = require("registration-controllers/BillingManager");

    // VIEWS
    var PlanView = require("registration-views/plan-selection/PlanView");

    // COLLECTION
    var BaseCollection = require("collections/BaseCollection");
    var PlansCollection = require('registration-collections/PlansCollection');

    var AssistedSaleView = {};
    LE.module('LERegistration', function (LERegistration, LE, Backbone, Marionette, $, _) {

        AssistedSaleView = Marionette.ItemView.extend({
            template: template,
            className: 'plan-selection-view',

            withUIComponents: true,
            ui: {
                nextBtn: ".button-next",
                cancelBtn: ".button-cancel",
                stepIndicator: ".step-indicator",
                plansView: ".view-container",
                chatBtn: ".chat-with-us",
                nonCatalogPersonalPlan: ".noncatalog-personal-plan-container .plan-box",
            },
            events: {
                "click .chat-with-us": "_onChat",
                "click .learn-more": "_onLearnMore",
            },
            uiComponents: {
                nextBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.nextBtn",
                        permutation: Button.PERMUTATION.BTN_PRIMARY,
                        initState: Button.STATES.ENABLED
                    },
                    events: {
                        "click": "_onNext"
                    }
                },
                cancelBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelBtn",
                        permutation: Button.PERMUTATION.LINK,
                        initState: Button.STATES.ENABLED
                    },
                    events: {
                        "click": "_onClosePage"
                    }
                },
                stepIndicator: {
                    type: StepIndicator,
                    options: "stepIndicatorOptions"
                }
            },

            initialize: function(options){
                LERegistration.logger.info("view initialize", "AssistedSaleView:initialize");
                this.mode= options.mode;
                this.parseTemplateHelpers();
                this.controller= options.controller;
                this.listenTo(this, "page:closeButtonClick", this._onClosePage);
            },

            parseTemplateHelpers: function(){
                var parsed= {};

                //TRIAL or PAYING
                parsed.mode= this.mode.toLowerCase();

                var personalPlan= this.model.get("collection").findWhere({"planType": PlansCollection.TYPES.PERSONAL});
                if(personalPlan){
                    parsed.personalPeriod=  personalPlan.get("baseBillingFrequencyMonths") === 12 ? "personal-annual" : (personalPlan.get("baseBillingFrequencyMonths") === 3 ? "personal-quarter" : "personal-month");
                }
                parsed.personalPlan= personalPlan;

                this.model.set('parsed', parsed);
                LERegistration.logger.debug("AssistedSaleView parsed model", "AssistedSaleView:parseTemplateHelpers", parsed);

            },
            onRender: function () {
                if(this.model.get("parsed.personalPlan") && !this.personalMode){
                    this.personalPlanView= new PlanView({model: this.model.get("parsed.personalPlan"), el: this.ui.nonCatalogPersonalPlan});
                    this.personalPlanView.render();
                }
            },
            
            _onChat: function(event){
                LERegistration.logger.info("Chat with us button was clicked","AssistedSaleView:_onChat");
                this.trigger(AssistedSaleView.TRIGGERING.CHAT_BUTTON_CLICKED);
            },
            _onLearnMore: function(event){
                LERegistration.logger.info("Learn more button was clicked","AssistedSaleView:_onLearnMore");
                LE.vent.trigger("openKP", {fragment: "billing-tier-change"});
            },
            _onClosePage: function() {
                LERegistration.logger.info("AssistedSaleView:_onClosePage");
                this.trigger(AssistedSaleView.TRIGGERING.CANCEL_BUTTON_CLICKED);
            },
            _onNext: function() {
                var selectedPlanName= this.model.get('productRatePlanName');
                LERegistration.logger.info("Pressed the next on the Assisted Sale page " + selectedPlanName, "AssistedSaleView:_onNext");
                LERegistration.vent.trigger("planSelectionView:next",this.model.get("parsed.personalPlan"));
            },
            stepIndicatorOptions: function(){
                var trial=
                    [
                        { text: LE.translator.translate("LERegistration.BuyNow.stepIndicator.step01"), state: StepIndicator.STATE.CURRENT},
                        { text: LE.translator.translate("LERegistration.BuyNow.stepIndicator.step2"), state: StepIndicator.STATE.NOT_COMPLETED},
                        { text: LE.translator.translate("LERegistration.BuyNow.stepIndicator.step3"), state: StepIndicator.STATE.NOT_COMPLETED}
                    ];
                var paying=
                    [
                        { text: LE.translator.translate("LERegistration.BuyNow.stepIndicator.step01"), state: StepIndicator.STATE.CURRENT},
                        { text: LE.translator.translate("LERegistration.BuyNow.stepIndicator.step3"), state: StepIndicator.STATE.NOT_COMPLETED}
                    ];
                return {
                    el: "view.ui.stepIndicator",
                    steps: this.mode === PlansCollection.MODES.TRIAL ? trial : paying
                };
            }

        });

    });

    AssistedSaleView.TRIGGERING= {
        CANCEL_BUTTON_CLICKED: "cancel",
        CHAT_BUTTON_CLICKED: "chat"
    };


    return AssistedSaleView;
});